import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { FeedbackPayload } from '../../application/types';

export async function sendFeedback(payload: FeedbackPayload) {
  await createPublicClient().post('/feedback/', payload);
}
